module.exports = __webpack_public_path__ + "static/media/arrow-from-left.410eda45.svg";